import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import ClientForm from "./ClientForm";
import InputCombo from "../../helpers/InputCombo";
import ClientReview from "./ClientReview";
import DialogServices from "./DialogServices";
import InputServicesMulti from "../../helpers/InputServicesMulti";
import ContractForm from "./ContractForm";
import ContractReview from "./ContractReview";
import FormatDecimal from "../../helpers/FormatDecimal";



function Locks(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   

       
        nazwa:  props.mainView.readFilter('nazwa',''),   
        wstrzymane_fakturowanie:  props.mainView.readFilter('wstrzymane_fakturowanie','_x_'),   
        aktualnie_wstrzymano_fakturowanie:  props.mainView.readFilter('aktualnie_wstrzymano_fakturowanie','_x_'),   
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([        
        {
            cls:'color_deleted',
            title: 'aktualnie wstrzymane fakturowanie',
            filter: {  filed: "aktualnie_wstrzymano_fakturowanie", set: "1", typ: "combo"  },
        },
    ]);




        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('nazwa', '');
            props.mainView.writeFilter('wstrzymane_fakturowanie', '_x_');
            props.mainView.writeFilter('aktualnie_wstrzymano_fakturowanie', '_x_');
       
           
            setFilterParam({

              
                nazwa: '',                 
                wstrzymane_fakturowanie: '_x_',                 
                aktualnie_wstrzymano_fakturowanie: '_x_',                 
             
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,locks', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


 

    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }

    



   useEffect( ()=>{

            if(Config.env == "dev") console.log("Locks.js, listener on");
            window.onkeydown = function (e) 
            {                        
                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }   else                        
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                           filterClear();
                        } else                                                                    
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                            setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        } else                                                                  
                        {
                               props.mainView.keyListener(e);
                        }
            };    
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Locks.js, listener off");             
                 window.onkeydown = null;
            };

    } );


    




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        setTab(null);       
    }



    if(tab == null)
    {
        setTab([]);
        getTab();         
        return <div>
            ...
        </div>
    }



    
    if(view.v == "review")
    {
        return <ClientReview userData={props.userData} mainView={props.mainView} onBack={onBack} onSuccess={onSuccess}  id={view.id}   />
    }


  
        var sortList = [                          
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
    ]


        document.title = "Lista blokad" ;


        

    return  <div className="view_content">


                 
               <h3 className="dash_header">Blokady</h3>
                              

    
               <div className="table_filter">

                        <div className="filter_controll">   
                                            <label>Nazwa: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                        </div>  

  
                        <div className="filter_controll">   
                                            <label>Wstrzymuj fakturowanie: </label>                             
                                            <InputCombo items = { [ {v:'_x_', title: '- - -'} , {v:'1', title: 'Tak, wstrzymuj'} , {v:'0', title: 'Nie, nie wstrzymuj'}    ] }   userData={props.userData} value={filterParam.wstrzymane_fakturowanie}   valChange={valChangeListener} goNext={goNextNew} name="wstrzymane_fakturowanie" placeholder={": "}   />
                        </div>  

                        <div className="filter_controll">   
                                            <label>Aktualnie wstrzymane: </label>                             
                                            <InputCombo items = { [ {v:'_x_', title: '- - -'} , {v:'1', title: 'Tak'} , {v:'0', title: 'Nie'}    ] }   userData={props.userData} value={filterParam.aktualnie_wstrzymano_fakturowanie}   valChange={valChangeListener} goNext={goNextNew} name="aktualnie_wstrzymano_fakturowanie" placeholder={": "}   />
                        </div>  

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                        
 

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Klient</td>                                                                                                                                       
                                                <td>Auto-Wstrzymywanie</td>                                                                                                                                       
                                                <td>Aktualnie zawieszone</td>                                                                                                                                       
                                                <td>Wtrzymane od</td>                                                                                                                                       
                                                <td>Wtrzymane do</td>                                                                                                                                       
                                                <td>Powód wstrzymania</td>                                                                                                                                       
                                                <td>Ostatnia wpłata</td>                                                                                                                                       
                                                <td className="td_right">Saldo</td>    
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
 

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td>{ix+1}</td>                                                          
                                                                <td>{row.klient.nazwa}</td>                                                          
                                                                <td className="gocenter">
                                                                    {
                                                                        row.wstrzymane_fakturowanie == 1  &&
                                                                        <Fragment>Tak</Fragment>
                                                                    }
                                                                    {
                                                                        row.wstrzymane_fakturowanie == 0  &&
                                                                        <Fragment>Nie</Fragment>
                                                                    }
                                                                </td>   
                                                                <td className="gocenter">
                                                                    {
                                                                        row.aktualnie_wstrzymano_fakturowanie == 1  &&
                                                                        <Fragment>Tak</Fragment>
                                                                    }  
                                                                    {
                                                                        row.aktualnie_wstrzymano_fakturowanie == 0  &&
                                                                        <Fragment>Nie</Fragment>
                                                                    }
                                                                </td>   
                                                                <td className="gocenter">{row.wstrzymane_od}</td>              
                                                                <td className="gocenter">{row.wstrzymane_do}</td> 
                                                                <td className="gocenter">{row.powod_wstrzymania}</td> 
                                                                <td className="gocenter">----</td> 
                                                                <td className="goright"><FormatDecimal value={row.klient.saldo} /></td> 
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView} >{row.numer_umowy }</td>                                                                                                                    
                                                                 <MenuTable>
                                                                    <ul>
                                                                        <li v="review" id={row.klient.id} onClick={changeView} >Pokaż klienta</li>                                                                        
                                                                    </ul>
                                                                </MenuTable>
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>

               </div>
 
              

                              
           

    </div>
}


export default Locks;